import clsx from 'clsx';
import type { KeyboardEvent } from 'react';
import { useLocaleInfo } from '../../../i18n/index.js';
import type { ViewGridState } from './types.js';
import { ViewGridCell } from './view-grid-cell.js';

/** @internal */
export function ViewGrid({ state, className }: { state: ViewGridState; className?: string }) {
  const { direction } = useLocaleInfo();

  const onKeyDown = (e: KeyboardEvent) => {
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        state.selectFocusedDate();
        break;
      case 'PageUp':
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousSection(e.shiftKey);
        break;
      case 'PageDown':
        e.preventDefault();
        e.stopPropagation();
        state.focusNextSection(e.shiftKey);
        break;
      case 'End':
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionEnd();
        break;
      case 'Home':
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionStart();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        e.stopPropagation();
        if (direction === 'rtl') {
          state.focusNextItem();
        } else {
          state.focusPreviousItem();
        }
        break;
      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousRow();
        break;
      case 'ArrowRight':
        e.preventDefault();
        e.stopPropagation();
        if (direction === 'rtl') {
          state.focusPreviousItem();
        } else {
          state.focusNextItem();
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();
        state.focusNextRow();
        break;
    }
  };
  return (
    <table
      role="grid"
      className={clsx('cim-date-picker-view-grid', className)}
      aria-label={state.header}
      aria-readonly={state.isReadOnly || undefined}
      aria-disabled={state.isDisabled || undefined}
      onKeyDown={onKeyDown}
      onFocus={() => state.setIsFocused(true)}
      onBlur={() => state.setIsFocused(false)}
    >
      <tbody>
        {state.data.map((row, idx) => (
          <tr key={idx}>
            {row.map((cellData, idx) => (
              <ViewGridCell cellData={cellData} key={cellData?.ariaLabel ?? idx} state={state} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
